/* global PUBLIC_PATH */
import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

/*
class Stars extends Component {
    async componentDidMount() {
        const response = await fetch(
            'https://api.github.com/repos/kutuluk/js13k-2d'
        );
        const json = await response.json();
        const stars = json.stargazers_count;

        this.setState({ stars });
    }

    render(props, { stars = 0 }) {
        let url = `//github.com/kutuluk/js13k-2d`;
        return (
            //<a href={url} class="stars">
            <div>
                <img src="assets/githubw.png" align="middle" />
                {stars} ⭐️
            </div>
            //</a>
        );
    }
}
*/

/*
            <Link
                activeClassName={style.active}
                href="//github.com/kutuluk/js13k-2d"
            >
                <Stars />
            </Link>

*/

// <img class={style.logo} src="assets/logo.png" />
const Header = () => (
	<header class={style.header}>
		<div class={style.brand}>
			<h1>js13k-2d</h1>
			<h5>A ~2kb webgl 2d sprite renderer</h5>
		</div>
		<nav>
			<Link activeClassName={style.active} href={`${PUBLIC_PATH}`}>
				Home
			</Link>
			<Link
				activeClassName={style.active}
				href={`${PUBLIC_PATH}bunnymark`}
			>
				Bunnymark
			</Link>
			<a href="//github.com/kutuluk/js13k-2d">
				<img whidth="32" height="32" src="assets/github.png" />
			</a>
		</nav>
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js